import { createContext, useContext } from 'react';

export type VirtualMultiselectRootContextValue = {
  value: string[];
  onValueChange: (value: string[]) => void;
  availableItemsSet: Set<string>;
  setAvailableItemsSet: (availableItemsSet: Set<string>) => void;
};

export const VirtualMultiselectRootContext =
  createContext<VirtualMultiselectRootContextValue | null>(null);

export const useVirtualMultiselectRoot = () => {
  const context = useContext(VirtualMultiselectRootContext);

  if (!context) {
    throw new Error(
      'useVirtualMultiselectRoot must be used within a VirtualMultiselectRootContextProvider',
    );
  }

  return context;
};
